import { Button, Grid, Box, Stack, Typography } from '@mui/material';
import { Container } from '@mui/system';
import { useEffect, useMemo, useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InputForm from '../../components/molecules/forms/inputForm';
import type { RootState } from '../../store';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../store';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import LoginSchema from '../../utils/validation/login';
import { useNavigate } from 'react-router-dom';
import { setToken } from '../../utils/storage';
import { useSubmitLoginMutation } from '../../store/feature/service/userApiSlice';
import Swal from 'sweetalert2';
import { MailOutline as MailOutlineIcon, Lock as LockIcon } from "@mui/icons-material";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import indonesiaImg from '../../assets/logo/Indonesia.png';
import korlantasImg from '../../assets/logo/korlantas-logo.png';
import trafficCar from '../../assets/logo/traffic-car.png';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isShowPass, setIsShowPass] = useState(false);
  const [submitLogin, { error: errorLogin, isLoading, isError }] = useSubmitLoginMutation();
  const { accesToken } = useAppSelector(
    (state: RootState) => state.user
  );

interface ILogin {
  email: string;
  password: string;
  showPass: boolean;
}

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ILogin>({
    reValidateMode: 'onChange',
    resolver: yupResolver(LoginSchema),
    defaultValues: {
      email: '',
      password: '',
      showPass: false,
    },
  });

  const onSubmit = async (data: ILogin) => {
    // submitLogin(data)
    setToken("123")
    navigate('/', { replace: true });
  };
  const endAdornment = useMemo(() => {
    if (isShowPass) {
      return <VisibilityIcon />;
    }
    return <VisibilityOffIcon />;
  }, [isShowPass]);

  const toggleShowPassword = () => {
    setIsShowPass((prev) => !prev);
  };

  useEffect(() => {
    if(isError) {
      let message = "Error Login, Please try again"
      try {
        const dataError: any = errorLogin
        message = dataError?.data.errors[0].detail
        if(message == "user not found") {
          message = "Incorrect username/password combination. Please check and try again"
        }
      } catch(e){}
      Swal.fire({
        icon: "error",
        title: "Error Login",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: message,
        didOpen: () => Swal.getConfirmButton()?.focus(),
      });
    }
  }, [isError]);

  useEffect(() => {
    if (accesToken) {
      setToken(accesToken)
      navigate('/', { replace: true });
    }
  }, [accesToken]);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#051438', // Change this to your desired color
      },
    },
  });

  return (
    <div style={{
        backgroundImage: `url(${indonesiaImg})`,
        backgroundSize: 'cover',
        backgroundColor: "#051438",
      }}>
      <Container maxWidth="sm">
        <Grid
          container
          spacing={2}
          direction="column"
          justifyContent="center"
          sx={{ minHeight: '105vh' }}>
        <Stack
          style={{
            display: 'grid',
            placeItems: 'center', // Centers both horizontally and vertically
          }}
        >
          <Box
            bgcolor="#FFFFFF"
            borderRadius={'50%'}
            boxShadow={3}
            width={'100px'}
            height={'100px'}
            textAlign="center"
            marginBottom={'-50px'}
            zIndex={1000}
            display= {'flex'}
            alignItems= {'center'}
            justifyContent= {'center'}
            >
              <img src={trafficCar} height={'55px'} width={'55px'}/>
            </Box>
          <Box
            pt={9}
            pb={5}
            pl={5}
            pr={5}
            bgcolor="#FFFFFF"
            borderRadius={4}
            boxShadow={3}
            maxWidth="500px"
            width="100%"
            textAlign="center"
            >
            <Grid
              container
              direction="column"
              component="form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Grid item>
                <Typography variant='h5' sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                  Welcome to Traffic Control Web
                </Typography>
              </Grid>
              <Grid
              item >
                <InputForm
                  name="Email"
                  errors={errors}
                  control={control}
                  required
                  placeholder="Email"
                  maxLength={100}
                  isLoading={false}
                  sxEndAdornment={{
                    backgroundColor: 'inherit',
                    border: 'none',
                    cursor: 'pointer',
                    width: '4rem',
                  }}
                  showStartAdornment
                  startAdornment={<MailOutlineIcon />}
                  sxFC={{ marginBottom: '1rem'}}
                />
              </Grid>
              <Grid item>
                <InputForm
                  name="Password"
                  errors={errors}
                  control={control}
                  type={isShowPass ? 'text' : 'password'}
                  placeholder="Password"
                  maxLength={127}
                  showEndAdornment
                  sxEndAdornment={{
                    backgroundColor: 'inherit',
                    border: 'none',
                    cursor: 'pointer',
                    width: '4rem',
                  }}
                  endAdornment={endAdornment}
                  onClickEndAdornment={toggleShowPassword}
                  required
                  showStartAdornment
                  startAdornment={<LockIcon />}
                  sxFC={{ marginBottom: '1.5rem'}}
                />
              </Grid>
              <Grid item>
                 {isLoading ? (
                <ThemeProvider theme={theme}>
                  <LoadingButton
                    loading
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="outlined"
                    fullWidth
                    color="secondary"
                    sx={{ borderRadius: '12px', textTransform: 'none' }}
                  >
                  Login
                  </LoadingButton>
                </ThemeProvider>
                ) : (
                  <ThemeProvider theme={theme}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ borderRadius: '12px', textTransform: 'none' }}
                    >
                    Login
                  </Button>
                </ThemeProvider>
                 )}
              </Grid>
            </Grid>
          </Box>
        </Stack>
        </Grid>
      </Container>
    </div>
  );
};


export default Login;
